import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preauthorize',
  templateUrl: './preauthorize.component.html',
  styleUrls: ['./preauthorize.component.css']
})
export class PreauthorizeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
